import {checkNarezkaForUral, countDecimalPlaces, getRulonUnit} from "../assets/constants";
import axios from "axios";

class CheckMods {

    checkMods = async (el, index) => {


        if (!this.props.product.pack_unit) return false

     //   if (el.sclad_id == -1) return false



        let pack_k = this.props.product.pack_unit.K;
        let countDecimail = countDecimalPlaces(pack_k)
        if (countDecimail < 3) {
            countDecimail = 4
        }
        let replaceZeros = ''
        while (replaceZeros.length < countDecimail) {
            replaceZeros += '0'
        }
        if (countDecimail > 0) {
            replaceZeros = '.' + replaceZeros
        } else {
            replaceZeros = '.000'
        }
        const narezka = checkNarezkaForUral(this.props.product)
        if (this.props.product.rulon && this.props.product.rulon.value == 'да') {
            el.product_is_rip = 1
        } else {
            el.product_is_rip = 0
        }

        let qnt = (el.quantity * el.order_unit.K / this.state.current_unit.K).toFixed(countDecimail).toString().replace(replaceZeros, '')

        let qnt_lim = 0
        let qnt_lim2 = 0
        let cnt = 0
        if (this.props.path && Array.isArray(this.props.path)) {
            for (let i = this.props.path.length - 1; i > 0; i--) {
                const path_item = this.props.path[i]
                if (path_item.qnt_lim * 1 > 0) {
                    qnt_lim = path_item.qnt_lim
                    qnt_lim2 = path_item.qnt_lim2
                    break
                }
            }
        }

        const ost = 1 * (el.ost_qnt * this.props.product.unit.K / this.state.current_unit.K).toFixed(countDecimail).toString().replace(replaceZeros, '');
        // const res = 1 * $(row).find('.res_qnt').html();

        const ost2 = ost - qnt;

        // На ненарезном складе для нарезного товара при выбранной ЕИ «рулон»
        // разрешаем отгрузку кратно целым рулонам (вместо требования «заказ = остаток»).
        const rulonUnit = getRulonUnit(this.props.product)
        const isRulonUnitSelected = !!(rulonUnit && this.state.current_unit
            && this.state.current_unit.external_id == rulonUnit.external_id)
        const rollScenario = isRulonUnitSelected && el.product_is_rip * 1 == 1 && el.is_rip * 1 == 0
            && this.props.user && !this.props.user.meta.settings.is_rip && el.sclad_id != -1
        let allowRollShipment = false
        if (rollScenario) {
            const q = qnt * 1
            // Series/PathDocs передают props.sclad и заранее переводят ost_qnt в current_unit;
            // в списке складов (Sclads) ost_qnt ещё в product.unit — берём вычисленный ost.
            const o = this.props.sclad ? el.ost_qnt * 1 : ost * 1
            allowRollShipment = q > 0 && q <= o + 0.0001
            // Кратность по рулону, кроме случая «весь остаток» (его по-прежнему пропускаем)
            if (allowRollShipment && Math.abs(q - o) > 0.0001) {
                pack_k = rulonUnit.K
            }
        }

        if(this.props.user.partner_id != 57) {
            if (el.sclad_id != -1 && this.props.user && !this.props.user.meta.settings.is_rip && el.is_rip * 1 == 0 && el.product_is_rip * 1 == 1
                && qnt * 1 != ost
                && !allowRollShipment
            ) {

                window.postMessage({
                    text: 'На складе ' + el.sclad_name + ' нельзя разрезать рулон. Необходимо выбить заказ равный остатку ',
                    type: "error",
                    timeout: 2000
                });

                cnt++;
                return true
            }
        } else {
            if (el.sclad_id != -1 && this.props.user && !this.props.user.meta.settings.is_rip && el.is_rip * 1 == 0 && (el.product_is_rip * 1 == 1 || narezka == true)
                && qnt * 1 != ost
                && !allowRollShipment
            ) {

                window.postMessage({
                    text: 'На складе ' + el.sclad_name + ' нельзя разрезать рулон. Необходимо выбить заказ равный остатку ',
                    type: "error",
                    timeout: 2000
                });

                cnt++;
                return true
            }
        }
        if (el.dont_mods == undefined && cnt == 0) {

            let cntLeft = 0
            let cntRight = 0

            let S = "0" + replaceZeros
            let base_qnt = 0

            if (pack_k > 0) {
                base_qnt = el.quantity * el.order_unit.K / this.props.product.base_unit.K
                //base_qnt = base_qnt / base_k;
                base_qnt = base_qnt.toFixed(countDecimail).replace(replaceZeros, '')
                base_qnt = base_qnt * 1

                S = base_qnt / pack_k
                S = S.toFixed(countDecimail)

            }

            let Buf = base_qnt

            let inc = countDecimail > 0 ? 1 : 0.001

            for (let z = 0; z < countDecimail; z++) {
                inc = inc / 10
            }
            if (!el.from_mods) {
                // Buf -= inc
                S = Buf / pack_k
                S = S.toFixed(countDecimail)

            }
            while (S.indexOf(replaceZeros) == -1 && Buf > 0.000000000) {

                Buf -= inc

                S = Buf / pack_k
                S = S.toFixed(countDecimail)
                cntLeft++
            }

            S = Buf * this.props.product.base_unit.K / el.order_unit.K
            S = S.toFixed(countDecimail).replace(replaceZeros, '')
            let min = S


            S = "0.0000"
            if (pack_k > 0) {

                S = base_qnt / pack_k
                S = S.toFixed(countDecimail)

            }

            Buf = base_qnt
            if (!el.from_mods) {
                //  Buf += inc

                S = Buf / pack_k
                S = S.toFixed(countDecimail)
            }
            while (S.indexOf(replaceZeros) == -1) {

                Buf += inc

                S = Buf / pack_k
                S = S.toFixed(countDecimail)
                cntRight++
            }

            S = Buf * this.props.product.base_unit.K / el.order_unit.K
            S = S.toFixed(countDecimail).replace(replaceZeros, '')
            let max = S

          //  console.log(this.props.product)
            if (cntRight > 0 || cntLeft || (this.props.product.isUnique == '1' && max != min)) {
                return {
                    current_max: max,
                    current_min: min,
                    current_item: el,
                    current_index: index,
                    current_pack_unit: (allowRollShipment && Math.abs(qnt * 1 - (this.props.sclad ? el.ost_qnt * 1 : ost * 1)) > 0.0001) ? rulonUnit : undefined
                }
            } else {
                if (this.props.ffc_mode && el.dont_firm_fit == undefined) {

                    const self = this
                    let promises = [];
                    let doc_data = null;
                    promises.push(
                        axios.get(this.props.base_url + "/?app=partnersproducts&act=checkProductInDocsIsFirmFitClub&product_id=" + this.props.product.id
                            + '&qnt=' + qnt + '&unit_id=' + this.state.current_unit.external_id + (this.state.current_phone ? '&current_phone=' + this.state.current_phone : ''),
                            {
                                withCredentials: true
                            }
                        ).then((response2) => {
                            doc_data = response2.data

                        }))
                    await Promise.all(promises).then(function () {
                        if (doc_data.cnt > 0) {
                            cnt++
                            self.setState({doc_data: doc_data})
                            self.showFirmFit(qnt)

                        }
                    })
                }


            }

        }

        return cnt > 0
    }

    constructor(props_, state_) {
        this.props = props_
        this.state = state_
        if (props_.showFirmFit) {
            this.showFirmFit = props_.showFirmFit.bind(this)
        }
        if (props_.setState) {
            this.setState = props_.setState.bind(this)
        }
        if (props_.krat_unit) {
            this.krat_unit = props_.krat_unit
        }
    }

}

export default CheckMods
